const blogs = [
      {
      id: 1,
      image: "/images/clerk-auth.jpg",
      alt: "blog 1",
      text: "To enable server-side rendering, Nextjs uses a special export named getServerSideProps. WithServerSideAuth helper from clerk is populated with the auth singleton.",
      name: "SSR with Nextjs and Clerk",
    },
    {
      id: 2,
      image: "/images/hooks.jpg",
      alt: "blog 2",
      text: "Hooks are the new feature introduced in the React 16.8 version. It allows you to use state and other React features without writing a class.",
      name: "React Hooks",
    },
    {
      id: 3,
      image: "/images/mern.png",
      alt: "blog 3",
      text: "A guide for newbie to deploy a Full stack MERN app using Netlify and Heroku.",
      name: "Deploy full stack MERN app",   
    },
    {
      id: 4,
      image: "/images/saas.png",
      alt: "blog 4",
      text: "SASS (Syntactically Awesome Stylesheet) is a CSS pre-processor, which helps to reduce repetition with CSS and saves time.",
      name: "Sass",   
    },
    {
      id: 5,
      image: "/images/life.jpg",
      alt: "blog 5",
      text: "If you're a recent graduate who's hesitant to jump into the real work world, consider doing something else with your time.",
      name: "Things to do after college",   
    },
  ]
  
  export default blogs;
  